var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.crossItems.length > 0
      ? _c(
          "div",
          {
            directives: [
              { name: "stick-in-parent", rawName: "v-stick-in-parent" },
            ],
            attrs: { "data-sticky-container": "#item-container" },
          },
          [
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "cross-selling-wrapper mt-2" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$translate(
                        "PerformanceWheels::Template.crossSellingAccessoryTitle"
                      )
                    )
                ),
                _c("span", { staticClass: "ml-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "PerformanceWheels::Template.crossSellingAccessoryTitleDescription"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cross-selling-row row no-gutters" },
                _vm._l(_vm.crossItems, function (crossItm) {
                  return _c(
                    "div",
                    {
                      key: crossItm.data.variation.itemId,
                      staticClass: "col-12 col-sm-6 col-lg-12",
                    },
                    [
                      _c("popper", {
                        staticClass:
                          "popper d-inline-flex align-self-center pr-2",
                        attrs: { placement: "left" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "handle",
                              fn: function () {
                                return [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-icon btn-secondary btn-sm p-2",
                                    },
                                    [_c("i", { staticClass: "fa fa-info" })]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        crossItm.data.texts.shortDescription
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c(
                        "article",
                        {
                          staticClass:
                            "cmp cmp-product-thumb h-100_X mb-0 p-0 accessory-item cross-item",
                          class: {
                            "cross-item-active": _vm.crossSellingItems.includes(
                              crossItm.data.variation.id
                            ),
                          },
                          attrs: {
                            "data-item-id": crossItm.data.variation.itemId,
                            "data-price":
                              crossItm.data.prices.default.unitPrice.value,
                            "data-variation-id": crossItm.data.variation.id,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.toggleCrossSellingItem(
                                crossItm.data.variation.id,
                                $event.target
                              )
                            },
                          },
                        },
                        [
                          _vm.hasItemTooltip(crossItm)
                            ? _c("div", {
                                directives: [
                                  { name: "tooltip", rawName: "v-tooltip" },
                                ],
                                staticClass: "cross-tooltip",
                                attrs: {
                                  "data-toggle": "tooltip",
                                  "data-placement": "top",
                                  title: crossItm.data.texts.shortDescription,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "thumb-inner d-flex flex-sm-column_X h-100",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "thumb-image col-3 col-sm-4" },
                                [
                                  _vm.hasItemImage(crossItm)
                                    ? _c("img", {
                                        attrs: {
                                          src: crossItm.data.images.all[0]
                                            .urlMiddle,
                                          alt: crossItm.data.texts.name1,
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "thumb-content d-flex flex-column col-9 col-sm-8",
                                },
                                [
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(crossItm.data.texts.name1) +
                                        "\n                  "
                                    ),
                                    _c("span", { staticClass: "unitNumber" }, [
                                      _vm._v(_vm._s(crossItm.data.texts.name2)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "prices d-flex align-items-end",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "price text-color-primary ml-auto",
                                        },
                                        [
                                          _vm._v(
                                            "\n                    + " +
                                              _vm._s(
                                                crossItm.data.prices.default
                                                  .unitPrice.formatted
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "single-item-bottom cross-selling-bottom" }, [
      _c("div", { staticClass: "container-max" }, [
        _c("div", { staticClass: "d-md-flex my-3" }, [
          _c("div", { staticClass: "d-flex_mt-2_ w-100 _container-fluid" }, [
            _c(
              "div",
              {
                staticClass: "single-price-basket _w-100 d-flex row no-gutters",
              },
              [
                !!_vm.currentVariation.filter &&
                _vm.currentVariation.filter.isSalable
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "order-2 additional-content-after-add-to-basket gtm-single-amazon align-self-center col-6 col-lg-3 text-right text-lg-left",
                      },
                      [
                        _c("div", { staticClass: "amzPayButton-custom" }, [
                          _vm.lang == "de"
                            ? _c("img", {
                                attrs: {
                                  height: "45",
                                  width: "200",
                                  src:
                                    _vm.pluginPathCw +
                                    "/images/payment/amazon_express_de.png",
                                  alt: "Amazon-Button",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addToBasketPaymentButton(
                                      _vm.currentVariation.variation.id,
                                      false
                                    )
                                  },
                                },
                              })
                            : _c("img", {
                                attrs: {
                                  height: "45",
                                  width: "200",
                                  src:
                                    _vm.pluginPathCw +
                                    "/images/payment/amazon_express_en.png",
                                  alt: "Amazon-Button",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addToBasketPaymentButton(
                                      _vm.currentVariation.variation.id,
                                      false
                                    )
                                  },
                                },
                              }),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentVariation.variation.itemType === "set"
                  ? _c("div", { staticClass: "col-12 alert_alert-info" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.singleItemSetInfo")
                          ) +
                          "\n            "
                      ),
                    ])
                  : _c(
                      "div",
                      {
                        staticClass:
                          "order-1 order-lg-3 btn-basket col-12 col-lg-6 ml-auto mb-2 mb-lg-0 ",
                      },
                      [
                        !!_vm.currentVariation.filter &&
                        _vm.currentVariation.filter.isSalable
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "single-detail-price text-right text-nowrap mr-4 mb-2 mb-sm-0 pr-0 col",
                                  attrs: { id: "cw-price" },
                                },
                                [
                                  _c("item-price", {
                                    staticClass: "mb-0",
                                    attrs: {
                                      "show-cross-price":
                                        _vm.isRecommendedPriceActive,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "vat small text-muted text-nowrap mb-0",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              _vm.getTxtSingleItemVat
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemExclusive"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.hasShippingCostsCategoryId
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                "data-toggle": "modal",
                                                href: "#shippingscosts",
                                                title: _vm.$translate(
                                                  "Ceres::Template.singleItemShippingCosts"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemShippingCosts"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              attrs: {
                                                title: _vm.$translate(
                                                  "Ceres::Template.singleItemShippingCosts"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemShippingCosts"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-sm-6 ml-auto btn-group",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-block btn-primary btn-appearance",
                                      attrs: { disabled: _vm.isLoading },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addToBasket(
                                            _vm.currentVariation.variation.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemAddToBasket"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _c(
                              "div",
                              { staticClass: "gtm-single-consultation" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-outline-primary p-4 w-100",
                                    attrs: {
                                      "data-toggle": "modal",
                                      href: "#consultation",
                                      disabled: _vm.isLoading,
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "PerformanceWheels::Template.singleItemBtnRequest"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                      ]
                    ),
                _vm._v(" "),
                !!_vm.currentVariation.filter &&
                _vm.currentVariation.filter.isSalable
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "order-1 col-6 col-lg-3 gtm-single-paypal align-self-center",
                      },
                      [
                        _c("div", { attrs: { id: "ppButton" } }, [
                          _c(
                            "a",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: { rel: "nofollow" },
                              on: {
                                click: function ($event) {
                                  return _vm.addToBasketPaymentButton(
                                    _vm.currentVariation.variation.id,
                                    true
                                  )
                                },
                              },
                            },
                            [
                              _vm.lang == "de"
                                ? _c("img", {
                                    attrs: {
                                      height: "32",
                                      width: "170",
                                      src:
                                        _vm.pluginPathCw +
                                        "/images/payment/paypal_express_de.png",
                                      alt: "Paypal-Button",
                                    },
                                  })
                                : _c("img", {
                                    attrs: {
                                      height: "32",
                                      width: "170",
                                      src:
                                        _vm.pluginPathCw +
                                        "/images/payment/paypal_express_en.png",
                                      alt: "Paypal-Button",
                                    },
                                  }),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }